import { mutate } from "swr";

const revalidateKeys = new Set([
    //'CURRENTUSER_CONTEXT',
    'PRIMARY_DATABASE_STATUS_START',
    'PRIMARY_DATABASE_STATUS_PING',
    'CASE_DATABASE_STATUS_PING',
    'CASES_FOR_CURRENT_CUSTOMER',
    'CASE_STATS',
    'CACHED_CASE_STATS',
]);

function isRevalidateKey(key) {
    // Exact string match
    if (typeof key === 'string') {
        console.log(`Checking if key "${key}" is in revalidateKeys`);
        return revalidateKeys.has(key);
    }
    // Array key — match if the first element is in our set
    if (Array.isArray(key) && key.length > 0) {
        console.log(`Checking if key array "${key[0]}" is in revalidateKeys`);
        return revalidateKeys.has(key[0]);
    }
    return false;
}

export default async function mutateClearCache() {
    mutate(
        key => !isRevalidateKey(key),
        undefined,
        { revalidate: false }
    );
    mutate(
        key => isRevalidateKey(key),
        undefined,
        { revalidate: true }
    );
    console.log("Cache cleared");
}